export const splitName = (name) => {
  let [firstName, ...rest] = name.split(" ");
  let lastName = rest.join(" ");

  return { firstName, lastName };
};
